import { observer } from 'mobx-react-lite';

import CheckoutCard from './CheckoutCard';
import { useCartContext } from 'screens/AccessExpressV3/CartProvider';

const CheckoutBody = observer(() => {
  const cart = useCartContext();

  return (
    <>
      <CheckoutCard
        items={cart.items}
        total={`$${cart.total}`}
        // subtotal={`$${cart.subTotal}`}
        // savings="$75.00"
        // discount="-$25.00"
        // taxes="$24.50"
        // shipping="$5.00"
      />
    </>
  );
});

export default CheckoutBody;
